'use strict';exports.__esModule = true;exports.parseSavedRecentSearches = exports.saveRecentSearch = undefined;var _reduxAct = require('redux-act');
var _takeRight = require('lodash/takeRight');var _takeRight2 = _interopRequireDefault(_takeRight);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);
var _omit = require('lodash/omit');var _omit2 = _interopRequireDefault(_omit);
var _constants = require('../../constants');
var _routerAdapter = require('../../helpers/routerAdapter');
var _formatRecentSearchData = require('../../utils/formatRecentSearchData');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var saveRecentSearch = (0, _reduxAct.createAction)('/SAVE_RECENT_SEARCH');
var parseSavedRecentSearches = (0, _reduxAct.createAction)('/PARSE_SAVED_RECENT_SEARCHES');

var RESENT_SEARCHES_STORAGE_KEY = 'OMRecentSearches';
var MAX_RESENT_SEARCHES_COUNT = 5;

var initialState = {
  data: [] };


var handleSaveRecentSearch = function handleSaveRecentSearch(state, routeData) {
  var data = [].concat(state.data);

  var searchData = (0, _formatRecentSearchData.generateRecentSearch)(routeData);

  var isDuplicate = data.some(function (search) {return (0, _isEqual2.default)((0, _omit2.default)(search, ['route']), searchData);});

  if (isDuplicate) {return Object.assign({}, state);}

  if (state.data.length >= MAX_RESENT_SEARCHES_COUNT) {
    data = (0, _takeRight2.default)(state.data, MAX_RESENT_SEARCHES_COUNT - 1);
  }

  var route = (0, _routerAdapter.createUrl)(routeData);
  var cleanRoute = route.
  split('/').
  filter(function (it) {return !_constants.language.supportedLanguages.includes(it);}).
  join('/');

  data.push(Object.assign({},
  searchData, {
    route: cleanRoute }));


  try {
    var searches = JSON.stringify(data);
    _constants.storage.value.setItem(RESENT_SEARCHES_STORAGE_KEY, searches);
  } catch (err) {
    console.error(err);
  }

  return Object.assign({},
  state, {
    data: data });

};

var handleParseSearches = function handleParseSearches(state) {
  var savesSearches = _constants.storage.value.getItem(RESENT_SEARCHES_STORAGE_KEY);
  var data = [];

  if (savesSearches) {
    try {
      data = JSON.parse(savesSearches);
    } catch (err) {
      console.error(err);
    }
  }

  return Object.assign({},
  state, {
    data: data });

};

var recentSearches = (0, _reduxAct.createReducer)(function (on) {
  on(saveRecentSearch, handleSaveRecentSearch);
  on(parseSavedRecentSearches, handleParseSearches);
}, initialState);exports.


saveRecentSearch = saveRecentSearch;exports.
parseSavedRecentSearches = parseSavedRecentSearches;exports.default =


recentSearches;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/recentSearches.js
// module id = 593
// module chunks = 0